import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { Card, Col, Container, Row, Tooltip } from 'react-bootstrap';
import Button from '../../../components/Button';
import GenericCard from '../../../components/GenericCards/GenericCards';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { RECENT_TRANSACTIONS_ROUTE } from '../../../routes/types';
import RecentTransactionsModal from '../../../pages/widgets/RecentTransactions/RecentTransactionsModal';
import { ModalManagementStore } from '../../../providers/modal-manager';
import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../../providers/recentTransactions';
import recentTransactionsData from '../../../data/retireeTransactions/retireeTransactions.json';

const GetClassName = (variant: string) => {
  let containerClassName;

  switch (variant) {
    case 'completed': {
      containerClassName = 'container-light-green';
      break;
    }

    case 'pending': {
      containerClassName = 'container-light-grey';
      break;
    }

    case 'deleted': {
      containerClassName = 'container-light-red';
      break;
    }
  }

  return containerClassName;
};
 

 
function TableData() {
  const { openModal } = useContext(ModalManagementStore);
  const {recentTransactions} = useContext(TransactionHistoryStore);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpenModal = (recentTransactions: any) => {
    setSelectedData(recentTransactions);
    setModalOpen(true);
  };


  const handleCloseModal = () => {
    setSelectedData(null);
    setModalOpen(false);
  };

  return (
    <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
      <Row>
        <Col
          className={
            'p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>Recent Transactions</h4>
        </Col>
      </Row>

      <Row>
        <GenericCard variant={'white'}>
          <Col>
            {recentTransactions.map((transaction, index) => {
              return (
                <Row
                  className={
                    'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                  }
                  key={index}
                >
                  <Col
                    className={
                      'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5'
                    }
                  >
                    <div>
                      <div
                        className={`status-box ${GetClassName(
                          transaction['status']
                        )}`}
                      >
                        <span
                          className={
                            'status-text text-capitalize text-caption display-flex'
                          }
                        >
                          {transaction['status']}
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                {transaction['statusTooltipInfo']}
                              </Tooltip>
                            }
                          >
                            {({ ref, ...triggerHandler }) => (
                              <span
                                className="ms-1"
                                ref={ref}
                                {...triggerHandler}
                              >
                                <FontAwesomeIcon
                                  icon={light('circle-question')}
                                />
                              </span>
                            )}
                          </OverlayTrigger>
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col
                    className={
                      'd-lg-block align-items-center col-lg-10 order-1 order-lg-4 py-6 px-5 py-lg-0'
                    }
                  >
                    <Card.Link
                      href="#"
                      className={
                        'py-5 m-0 text-fs-6 order-1 color-link text-blue nav-link-text'
                      }
                      onClick={() => handleOpenModal(transaction)}
                    >
                      {transaction['transactionType']}
                    </Card.Link>
                    <OverlayTrigger overlay={<Tooltip>{transaction['transactionTooltipInfo']}</Tooltip>}>
                      {({ ref, ...triggerHandler }) => (
                        <span className="ms-1" ref={ref} {...triggerHandler}>
                          <FontAwesomeIcon
                            color={'salmon'}
                            icon={light('circle-exclamation')}
                          />
                        </span>
                      )}
                    </OverlayTrigger>

                    <br></br>
                    <span
                      className={
                        'm-0 text-fs-6 order-1 color-link nav-link-text py-3'
                      }
                    >
                      <strong>{transaction['planName']} </strong>{' '}
                    </span>
                  </Col>
                </Row>
              );
            })}
          </Col>
          {/* Reusable Transactions Modal */}
          {selectedData && (
            <RecentTransactionsModal
              showRecentTransactionsModal={isModalOpen}
              handleCloseRecentTransactionsModal={handleCloseModal}
              data={selectedData}
              currentStep={0}
              goToStep={function (): void {
                throw new Error('Function not implemented.');
              }}

              
            />
          )}
          <Row className={'m-0 p-0 py-8'}>

            
            <Button
              size={'sm'}
              rightIcon={light('list-timeline')}
              href={`#${RECENT_TRANSACTIONS_ROUTE}`}
            >
              {'Transaction History'}
            </Button>    
          </Row>
        </GenericCard>
      </Row>
    </Container>
  );
}

const recentTransactions = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default recentTransactions;
